import { BaseValue } from "../../consts/base-value";

export class RedirectPath extends BaseValue<string> {
  constructor(value: string) {
    // URI encodeされている場合、decodeする
    super(value.match(/^%2F/) ? decodeURIComponent(value) : value);

    // pathの先頭は`/`から始まることを要求
    if (!this.getValue().match(/^\//)) {
      throw new Error(`Invalid RedirectPath: [${value}]`);
    }
  }
}
